import { render, staticRenderFns } from "./study-rank-data.vue?vue&type=template&id=5c73d920&scoped=true&"
import script from "./study-rank-data.vue?vue&type=script&lang=js&"
export * from "./study-rank-data.vue?vue&type=script&lang=js&"
import style0 from "./study-rank-data.vue?vue&type=style&index=0&id=5c73d920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73d920",
  null
  
)

export default component.exports